export default "__VITE_ASSET__Dz2sk8ZI__"